export const navigateToDashboard = (navigate) =>{
    navigate("/Players",{ replace: true })
}

export const navigateToLogin = (navigate) =>{
    navigate("/Login",{ replace: true })
}